<template>
  <div class="steps-header">
    <el-steps :active="fixedStepIndex" align-center>
      <el-step
        v-for="(step, index) in steps"
        :key="step.title"
        :title="step.title"
        :description="step.description"
        :status="stepStatus(index)"
        @click="() => handleStepClick(index)"
      />
    </el-steps>
  </div>
</template>

<script setup>

const props = defineProps({
  fixedStepIndex: {
    type: [Number, String],
    default: 0,
  },
  currentStepIndex: {
    type: [Number, String],
    default: 0,
  },
  steps: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['step-click'])

const stepStatus = (stepIndex) => {
  if (stepIndex < props.currentStepIndex) {
    return 'success'
  }
  if (stepIndex === Number(props.currentStepIndex)) {
    return 'process'
  }
  return ''
}

const handleStepClick = (index) => {
  emit('step-click', index)
}
</script>

<style lang="scss" scoped>
.steps-header {
  padding: 16px 0;
  background: #fff;
}
</style>
